import CartaoHub from '@/pages/gerenciar/painel/CartaoHub';

export type TelaDia =
  | 'vendas'
  | 'barracas'
  | 'servindo'
  | 'maquininhas'
  | 'portaria'
  | 'fichas'
  | 'estado';

interface Props {
  temLoja: boolean;
  vendeIngressos: boolean;
  /** Entrada franca: sem ingresso para ler na portaria. */
  entradaFranca?: boolean;
  vendasHojeCentavos: number;
  noCelular: number;
  convitesAguardando: number;
  portaria: { entraram: number; validos: number } | null;
  aoAbrir: (tela: TelaDia) => void;
  aoAbrirCaixa: () => void;
  aoImprimirFichas: () => void;
}

// Dinheiro curto para caber no número do cartão (375px). Sempre com centavos.
function dinheiroCurto(centavos: number): string {
  const reais = (Number(centavos) || 0) / 100;
  if (reais >= 1000) {
    const mil = reais / 1000;
    return `R$ ${mil.toLocaleString('pt-BR', { maximumFractionDigits: 1 })} mil`;
  }
  return `R$ ${reais.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

// Hub da aba "Dia do evento": caixa, vendas, barracas, quem serve, portaria e fichas.
export default function HubDiaEvento({
  temLoja,
  vendeIngressos,
  entradaFranca = false,
  vendasHojeCentavos,
  noCelular,
  convitesAguardando,
  portaria,
  aoAbrir,
  aoAbrirCaixa,
  aoImprimirFichas,
}: Props) {
  return (
    <div className="space-y-2.5 lg:grid lg:grid-cols-3 lg:gap-3 lg:space-y-0">
      {temLoja && (
        <CartaoHub
          icone="ri-cash-line"
          titulo="Abrir o caixa"
          descricao="Vender ficha, cobrar cartão e imprimir"
          cor="primary"
          aoClicar={aoAbrirCaixa}
        />
      )}

      <CartaoHub
        icone="ri-line-chart-line"
        titulo="Vendas de hoje"
        descricao="Quanto entrou, por meio e por barraca"
        numero={dinheiroCurto(vendasHojeCentavos)}
        legenda="vendido hoje"
        cor="accent"
        aoClicar={() => aoAbrir('vendas')}
      />

      {temLoja && (
        <CartaoHub
          icone="ri-store-2-line"
          titulo="Barracas e produtos"
          descricao="Barracas, cardápio, preços e pausar"
          cor="primary"
          aoClicar={() => aoAbrir('barracas')}
        />
      )}

      <CartaoHub
        icone="ri-team-line"
        titulo="Quem está servindo"
        descricao={
          convitesAguardando > 0
            ? `${convitesAguardando} ${convitesAguardando === 1 ? 'convite aguardando' : 'convites aguardando'}`
            : 'Convites, cartazes e chamar pessoa'
        }
        numero={String(noCelular)}
        legenda="pessoas hoje"
        cor="secondary"
        aoClicar={() => aoAbrir('servindo')}
      />

      {temLoja && (
        <CartaoHub
          icone="ri-bank-card-line"
          titulo="Maquininhas e caixas"
          descricao="Mercado Pago Point e caixas do evento"
          cor="secondary"
          aoClicar={() => aoAbrir('maquininhas')}
        />
      )}

      {vendeIngressos && !entradaFranca && (
        <CartaoHub
          icone="ri-door-open-line"
          titulo="Portaria"
          descricao="Ler o QR do ingresso na entrada"
          numero={portaria ? String(portaria.entraram) : '—'}
          legenda={portaria ? `de ${portaria.validos} válidos` : 'válidos'}
          cor="accent"
          aoClicar={() => aoAbrir('portaria')}
        />
      )}

      {temLoja && (
        <CartaoHub
          icone="ri-qr-code-line"
          titulo="Link e cartaz das fichas"
          descricao="Copiar, mandar no WhatsApp e imprimir cartaz"
          cor="primary"
          aoClicar={() => aoAbrir('fichas')}
        />
      )}

      {temLoja && (
        <CartaoHub
          icone="ri-printer-line"
          titulo="Fichas de papel para imprimir"
          descricao="Blocos de ficha para vender no dinheiro"
          cor="secondary"
          aoClicar={aoImprimirFichas}
        />
      )}

      {temLoja && (
        <CartaoHub
          icone="ri-toggle-line"
          titulo="Vendas pelo site"
          descricao="Abertas, fechadas ou com hora para abrir"
          cor="accent"
          aoClicar={() => aoAbrir('estado')}
        />
      )}
    </div>
  );
}